/** @file Resolves the one or two bone references of an IK chain to ids, keeping the tuple shape. */
import type { Id } from '@pose2d/format/types';
import type { CommandContext } from '../commandContext';

/** `[parent]` or `[parent, child]` names/ids → ids (NOT_FOUND for an unknown reference). */
export function resolveChain(ctx: CommandContext, refs: [string] | [string, string]): [Id] | [Id, Id] {
  const first = ctx.resolve('bone', refs[0]);
  return refs.length === 1 ? [first] : [first, ctx.resolve('bone', refs[1])];
}
